let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fDqSS")).then(() => parcelRequire('48GVS'));